/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApiResponse } from '../../types/apiTypes';
import { VisitorType } from '../../types/VisitorTypeTypes';

export interface VisitorTypesState {
  visitorTypes: ApiResponse<VisitorType>;
  fetchVisitorTypesLoading: boolean;
  error: string | null;
}

const initialState: VisitorTypesState = {
  visitorTypes: {
    data: [],
    meta: null,
    totalCount: 0,
    filteredCount: 0,
  },
  fetchVisitorTypesLoading: false,
  error: null,
};

type VisitorTypesLoadingKey = 'fetchVisitorTypesLoading';

const visitorTypesSlice = createSlice({
  name: 'visitorTypes',
  initialState,
  reducers: {
    fetchVisitorTypes(state, _action: PayloadAction<{ orgId: number }>) {
      state.error = null;
    },

    setVisitorTypes(state, action: PayloadAction<ApiResponse<VisitorType>>) {
      state.visitorTypes = action.payload;
    },

    setLoading(
      state,
      action: PayloadAction<{ key: VisitorTypesLoadingKey; value: boolean }>,
    ) {
      state[action.payload.key] = action.payload.value;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    clearVisitorTypesState() {
      return initialState;
    },
  },
});

export const {
  fetchVisitorTypes,
  setVisitorTypes,
  setLoading,
  setError,
  clearVisitorTypesState,
} = visitorTypesSlice.actions;

export const visitorTypesActions = visitorTypesSlice.actions;
export default visitorTypesSlice.reducer;
